import { render, staticRenderFns } from "./BlackListTable.vue?vue&type=template&id=002251b4&scoped=true"
import script from "./BlackListTable.vue?vue&type=script&lang=js"
export * from "./BlackListTable.vue?vue&type=script&lang=js"
import style0 from "./BlackListTable.vue?vue&type=style&index=0&id=002251b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002251b4",
  null
  
)

export default component.exports